import { Draggable, Droppable } from "@hello-pangea/dnd";
import { MenuDndItemsType } from "@/common/type/type";
import { Box } from "@/common/styles/style";
import { styles } from "./style";

interface MenuProps {
  menuItems: MenuDndItemsType;
}

export default function Menu({ menuItems }: MenuProps) {
  return (
    <Droppable droppableId="menu">
      {(provided) => (
        <Box
          ref={provided.innerRef}
          {...provided.droppableProps}
          style={styles.droppableBox}
        >
          {menuItems.map((item, index) => (
            <Draggable key={item.id} draggableId={item.id} index={index}>
              {(provided) => (
                <div
                  ref={provided.innerRef}
                  {...provided.draggableProps}
                  {...provided.dragHandleProps}
                  style={{
                    ...provided.draggableProps.style,
                    ...styles.droggableDiv,
                  }}
                >
                  {item.content}
                </div>
              )}
            </Draggable>
          ))}
          {provided.placeholder}
        </Box>
      )}
    </Droppable>
  );
}
